import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

import it from './custom-paginator-intl.it.json';

export class CustomPaginatorIntl extends MatPaginatorIntl {

  constructor(private translateSvc: TranslocoService) {
    super();
    this.translateSvc.setTranslation(it, 'it');
    this.itemsPerPageLabel = this.translateSvc.translate('paginator.itemsPerPageLabel');
    this.nextPageLabel     = this.translateSvc.translate('paginator.nextPageLabel');
    this.previousPageLabel = this.translateSvc.translate('paginator.previousPageLabel');
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string  => {
    length = Math.max(length, 0);
    let start = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const end = start < length ? Math.min(start + pageSize, length) : start + pageSize;
    start++;
    return this.translateSvc.translate('paginator.rangeLabel', {start, end, length});
  };

}
